/**
 * Kleine uuid-helper.
 *
 * `crypto.randomUUID` bestaat in Node 19+ en in alle moderne browsers, maar
 * niet in elke omgeving waarin dit package wordt geïmporteerd (bijvoorbeeld
 * een test in een oude jsdom). Daarom een expliciete helper met een fallback.
 */
export function randomUUID(): string {
  const globaleCrypto = globalThis.crypto as { randomUUID?: () => string } | undefined;
  if (globaleCrypto?.randomUUID) return globaleCrypto.randomUUID();
  // Fallback volgens RFC 4122 versie 4. Alleen gebruikt als er geen
  // crypto.randomUUID is; niet bedoeld voor cryptografie.
  const bytes = new Uint8Array(16);
  for (let i = 0; i < 16; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
